import {
  Consultation,
  ConsultationResponse,
  ConsultationResponseAnswer,
} from '../../../../types';

/**
 * The function `getAnswers` takes in a consultation, a response, a consultee ID, and a consultee
 * name, and returns an array of consultation response answers.
 * @param {Consultation} consultation - The consultation object that contains the questions for the
 * consultation.
 * @param {ConsultationResponse | undefined} response - The `response` parameter is of type
 * `ConsultationResponse | undefined`. It represents the response given by the consultee to the
 * consultation. It can be either a valid `ConsultationResponse` object or `undefined` if no response
 * has been given yet.
 * @param {number} consulteeId - The ID of the consultee who is providing the consultation response.
 * @param {string} consulteeName - The `consulteeName` parameter is a string that represents the name
 * of the consultee.
 */
export const getAnswers = (
  consultation: Consultation,
  response: ConsultationResponse | undefined,
  consulteeId: number,
  consulteeName: string
): ConsultationResponseAnswer[] =>
  consultation.questions.map((question) => {
    const answer = response?.answers.find((a) => a.questionId === question.id);
    return {
      id: answer?.id,
      responseId: response?.id,
      consulteeId: answer?.consulteeId ?? consulteeId,
      consulteeName: answer?.consulteeName ?? consulteeName,
      questionId: question.id,
      question: answer?.question ?? question.text,
      answer: answer?.answer ?? question.defaultAnswer,
      approved: answer?.approved ?? false,
      questionNumber: answer?.questionNumber ?? question.questionNumber,
      dateCreated: answer?.dateCreated,
      dateModified: answer?.dateModified,
      dateApproved: answer?.dateApproved,
      organisation: answer?.organisation,
    };
  });
